interface IdleInstance {
    start(): void;
    stop(): void;
}

let idleInstance: IdleInstance | null = null

export function setIdleInstance(instance: IdleInstance) {
    idleInstance = instance
}

export function startIdle() {
    idleInstance?.start()
}

export function stopIdle() {
    idleInstance?.stop()
}
